<template>
  <div class="d-flex">
    <v-btn :to="{ name: 'accueil' }" exact variant="text" class="d-none d-lg-flex" prepend-icon="mdi-home">
      Accueil
    </v-btn>
    <v-btn :to="{ name: 'rivieres' }" variant="text" class="d-none d-lg-flex" prepend-icon="mdi-map-search">
      Rivières
    </v-btn>
    <v-btn :to="{ name: 'dangers' }" variant="text" class="d-none d-lg-flex" prepend-icon="mdi-alert-outline">
      Dangers
    </v-btn>
    <v-btn :to="{ name: 'partenaires' }" variant="text" class="d-none d-lg-flex" prepend-icon="mdi-handshake">
      Partenaires
    </v-btn>
    <v-btn :to="{ name: 'a-propos' }" variant="text" class="d-none d-lg-flex" prepend-icon="mdi-information-outline">
      À propos
    </v-btn>
  </div>
</template>

<script>
  // The active page gets a gold underline (docs/BRAND.md)
  export default {
    name: "TopNavLinks",
    props: {
      isMember: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped>
  /* Active page: gold underline under the label, on top of Vuetify's light overlay */
  .v-btn--active {
    box-shadow: inset 0 -3px 0 rgb(var(--v-theme-gold));
  }
</style>
